export const AUTH_TOKEN = "nftiz_dash_auth_token";

export const ADVERTISER = 'advertiser';
export const PUBLISHER = 'publisher';
